import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { useTransition } from "../contexts/TransitionContext";

interface TransitionWrapperProps {
  children: React.ReactNode;
}

export const TransitionWrapper = ({ children }: TransitionWrapperProps) => {
  const { contentOpacity } = useTransition();
  const location = useLocation();
  const prevLocationRef = useRef(location.pathname);

  // Track location changes for future use
  useEffect(() => {
    prevLocationRef.current = location.pathname;
  }, [location.pathname]);

  return (
    <div
      key={location.pathname}
      style={{
        opacity: contentOpacity,
        transition: "opacity 200ms ease-in-out",
        width: "100%",
        height: "100%",
      }}
    >
      {children}
    </div>
  );
};
